import styled from 'styled-components';
import { DataTable as PrimeReactDataTable } from 'primereact/datatable';

const DataTable = styled(PrimeReactDataTable)`
  .p-datatable-tbody {
    cursor: pointer;
  }
`;

export { DataTable };
